/**
 * Entrypoint principal de configuración de marca
 *
 * Este archivo exporta la configuración de marca (Agencias / Happi)
 * para que el CORE pueda consumirla a través del alias @brand
 *
 * El CORE debe tener configurado en vite.config.ts:
 *   resolve: {
 *     alias: {
 *       '@brand': path.resolve(__dirname, '../brand/src')
 *     }
 *   }
 *
 * Uso en el CORE:
 *   import config from '@brand/config'
 *   // o
 *   import { companyConfig, assetsConfig, colorsConfig } from '@brand/config'
 */

import * as agencias from './projects/agencias';
import * as happi from './projects/happi';

type ProjectKey = 'agencias' | 'happi';

// Leemos la variable de entorno que viene de Vite (VITE_CONFIG_COMPANY)
const envProject = (import.meta as any).env?.VITE_CONFIG_COMPANY as ProjectKey | undefined;

// Si no viene o viene algo raro, caemos en 'agencias' para mantener compatibilidad
const projectKey: ProjectKey = envProject === 'happi' ? 'happi' : 'agencias';

const projects: Record<ProjectKey, any> = {
  agencias,
  happi,
};

const selectedProject = projects[projectKey];

// Re-exportar configs del proyecto seleccionado
export const companyConfig = selectedProject.companyConfig;
export const assetsConfig = selectedProject.assetsConfig;
export const colorsConfig = selectedProject.colorsConfig;
export const typographyConfig = selectedProject.typographyConfig;

// Config completa
export const config =
  selectedProject.config ??
  {
    company: companyConfig,
    assets: assetsConfig,
    colors: colorsConfig,
    ...(typographyConfig ? { typography: typographyConfig } : {}),
  };

// Exportación por defecto
export default config;